export class ApplicationsFilter {
    public code: string;
    public applicationTypeId?: number;
    public state?: number;
    public hasUnreadMessages?: number;
    public employeeName: string;
    public registeredFrom?: Date;
    public registeredTill?: Date;
    public decisionFrom?: Date;
    public decisionTill?: Date;
    public isCorrection: boolean;
    public hasRequestForCancel: boolean;
    public applicantCodeOrName: string;
    public dpkDeferment: boolean;
    public page: number;
    public pageSize: number;
    public sortBy: string;
    public sortDirection: string;
}
